export const getRandomColorCode = () => {
  const randomColorCodes = [
    '#55efc4',
    '#81ecec',
    '#74b9ff',
    '#a29bfe',
    '#dfe6e9',
    '#00b894',
    '#00cec9',
    '#6c5ce7',
    '#b2bec3',
    '#ffeaa7',
    '#fab1a0',
    '#ff7675',
    '#fd79a8',
    '#636e72',
    '#fdcb6e',
    '#e17055',
    '#d63031',
    '#e84393',
  ];
  return randomColorCodes[Math.floor(Math.random() * 18)];
};

export const getRandomFromArray = (arr) => {
  const max = arr.length;
  const min = 0;
  const index = Math.floor(Math.random() * (max - min + 1) + min);
  return arr[index];
};
